import { render, staticRenderFns } from "./create-user-by-file.vue?vue&type=template&id=327f4f44"
import script from "./create-user-by-file.vue?vue&type=script&lang=js"
export * from "./create-user-by-file.vue?vue&type=script&lang=js"
import style0 from "./create-user-by-file.vue?vue&type=style&index=0&id=327f4f44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports